import React , { useEffect}  from 'react';
import { BrowserRouter as Router, Routes, Route,useLocation } from 'react-router-dom';
import Header from './components/Header';
import StockTicker from './components/StockTicker';
import GlobalBanner from './components/GlobalBanner';
import Footer from './components/Footer';
import './App.css';
import Navbar from './components/Navbar';
import TopHomepageAd from './components/TopHomepageAd';
import ScrollButtons from './components/ScrollButtons';
// import BottomBanner from './pages/BottomBanner';
// import Breadcrumb from './components/Breadcrumb';

// Import Pages
import Home from './pages/Home';
import Markets from './pages/Markets';
import Economics from './pages/Economics';
import Industries from './pages/Industries';
import Tech from './pages/Tech';
import Politics from './pages/Politics';
import Businessweek from './pages/Businessweek';
import Opinion from './pages/Opinion';
import TerminalDemo from './pages/TerminalDemo';
import CustomerSupport from './pages/CustomerSupport';
import Article from './pages/Article';
import LatestNewsArticle from './pages/latestNews/LatestNewsArticle';
import Subscribe from './pages/Subscribe';
import Deals from './pages/marketsNews/Deals';
import FixedIncome from './pages/marketsNews/FixedIncome';
import ETFs from './pages/marketsNews/ETFs';
import FX from './pages/marketsNews/FX';
import AltInvesting from './pages/marketsNews/AltInvesting';
import EconomicCalendar from './pages/marketsNews/EconomicCalendar';
import Wealth from './pages/Wealth';
import Pursuits from './pages/Pursuits';
import CityLab from './pages/CityLab';
import Sports from './pages/Sports';
import Equality from './pages/Equality';
import ManagementWork from './pages/ManagementWork';
import Originals from './pages/Originals';
import RedboxTV from './pages/RedboxTV';
import Podcasts from './pages/Podcasts';
import Radio from './pages/Radio';
import LiveEvents from './pages/LiveEvents';
import LiveQA from './pages/LiveQA';
import Newsletters from './pages/Newsletters';
import Weekend from './pages/Weekend';
import Graphics from './pages/Graphics';
import TheBigTake from './pages/TheBigTake';
import Explainers from './pages/Explainers';
import NewsQuiz from './pages/NewsQuiz';
import Alphadots from './pages/Alphadots';
import MarketsMagazine from './pages/MarketsMagazine';
import Investigations from './pages/Investigations';
import Watchlist from './pages/Watchlist';
import AboutUs from './pages/AboutUs';
import Careers from './pages/Careers';
import InclusionAtRedboxGlobal from './pages/InclusionAtRedboxGlobal';
import Philanthropy from './pages/Philanthropy';
import Sustainability from './pages/Sustainability';
import RedboxGlobalBeta from './pages/RedboxGlobalBeta';
import TechAtRedboxGlobal from './pages/TechAtRedboxGlobal';
import RedboxProfessionalServices from './pages/RedboxProfessionalServices';
import SubmitTip from './pages/SubmitTip';
// import HelpCenter from './pages/HelpCenter';
import MediaStudios from './pages/MediaStudios';
import RedboxTerminal from './pages/RedboxTerminal';
import RedboxData from './pages/RedboxData';
import RedboxTrading from './pages/RedboxTrading';
import RedboxRisk from './pages/RedboxRisk';
import RedboxCompliance from './pages/RedboxCompliance';
import RedboxIndices from './pages/RedboxIndices';
import PressAnnouncements from './pages/PressAnnouncements';
import PressContacts from './pages/PressContacts';
import RedboxGlobalLaw from './pages/RedboxGlobalLaw';
import RedboxGlobalTax from './pages/RedboxGlobalTax';
import RedboxGovernment from './pages/RedboxGovernment';
import RedboxNEF from './pages/RedboxNEF';
import RedboxAdvertising from './pages/RedboxAdvertising';
import Checkout from './pages/Checkout';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import OpinionDetail from './pages/OpinionDetail';
import RemoteLogin from './pages/RemoteLogin';
import LiveTv from './pages/LiveTv';
import RedboxYoutube from './pages/RedboxYoutube';
import LearnMore from "./pages/LearnMore";
import TermsOfService from "./pages/TermsofService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookieSettings from "./pages/CookieSettings";
import Help from "./pages/Help";
import ForgotPassword from "./pages/ForgotPassword";




/* Scroll To Top on Route Change */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}



// function App() {

function Layout() {
  const location = useLocation();


 // ✅ Show ticker ONLY on homepage
  const showStockTicker = location.pathname === "/";


  

  

  const showTopAd = location.pathname === "/";

  



  // Hide scroll buttons on Sign In, Sign Up and Remote Login pages
  const hideScrollButtons = ["/signin", "/signup", "/remote-login"].includes(location.pathname);

 
  

  


  return (
    
      <div className="App">
        <div className="reading-progress"></div>
        {/* <Breadcrumb /> */}
        <ScrollToTop />


       
       
        {/* 🔥 Bloomberg-style: Ad scrolls naturally above sticky header */}
        {showTopAd && <TopHomepageAd />}
       

            


      



        {/* Sticky header block — Header + Navbar stick together, no fluctuation */}
        <div className="site-header">
          <Header />
          <Navbar />
        </div>

       {/* ✅ Only visible on homepage */}
      {showStockTicker && <StockTicker />}
      {showStockTicker && <GlobalBanner />}


       
      
  

       
      

      
      

        {/* <StockTicker /> */}

        <main className="main-page-content">
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/economics" element={<Economics />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/tech" element={<Tech />} />
          <Route path="/politics" element={<Politics />} />
          <Route path="/businessweek" element={<Businessweek />} />
          <Route path="/opinion" element={<Opinion />} />
          <Route path="/terminal-demo" element={<TerminalDemo />} />
          <Route path="/support" element={<CustomerSupport />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/latest-news/:slug" element={<LatestNewsArticle />} />
          <Route path="/markets/deals" element={<Deals />} />
          <Route path="/markets/fixed-income" element={<FixedIncome />} />
          <Route path="/markets/etfs" element={<ETFs />} />
          <Route path="/markets/fx" element={<FX />} />
          <Route path="/markets/alternative-investing" element={<AltInvesting />} />
          <Route path="/markets/economic-calendar" element={<EconomicCalendar />} />
          <Route path="/wealth" element={<Wealth />} />
          <Route path="/pursuits" element={<Pursuits />} />
          <Route path="/citylab" element={<CityLab />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/equality" element={<Equality />} />
          <Route path="/management-work" element={<ManagementWork />} />
          <Route path="/originals" element={<Originals />} />
          <Route path="/redbox-tv" element={<RedboxTV />} />
          <Route path="/podcasts" element={<Podcasts />} />
          <Route path="/radio" element={<Radio />} />
          <Route path="/live-events" element={<LiveEvents />} />
          <Route path="/live-qa" element={<LiveQA />} />
          <Route path="/newsletters" element={<Newsletters />} />
          <Route path="/weekend" element={<Weekend />} />
          <Route path="/graphics" element={<Graphics />} />
          <Route path="/the-big-take" element={<TheBigTake />} />
          <Route path="/explainers" element={<Explainers />} />
          <Route path="/news-quiz" element={<NewsQuiz />} />
          <Route path="/alphadots" element={<Alphadots />} />
          <Route path="/markets-magazine" element={<MarketsMagazine />} />
          <Route path="/investigations" element={<Investigations />} />
          <Route path="/watchlist" element={<Watchlist />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/inclusion" element={<InclusionAtRedboxGlobal />} />
          <Route path="/philanthropy" element={<Philanthropy />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/beta" element={<RedboxGlobalBeta />} />
          <Route path="/techatredboxGlobal" element={<TechAtRedboxGlobal />} />
          <Route path="/submit-tip" element={<SubmitTip />} />
          {/* <Route path="/help-center" element={<HelpCenter />} /> */}
          <Route path="/media-studios" element={<MediaStudios />} />
          <Route path="/professional-services" element={<RedboxProfessionalServices />} />
          <Route path="/terminal" element={<RedboxTerminal />} />
          <Route path="/data" element={<RedboxData />} />
          <Route path="/trading" element={<RedboxTrading />} />
          <Route path="/risk" element={<RedboxRisk />} />
          <Route path="/compliance" element={<RedboxCompliance />} />
          <Route path="/indices" element={<RedboxIndices />} />
          <Route path="/press-announcements" element={<PressAnnouncements />} />
          <Route path="/press-contacts" element={<PressContacts />} />
          <Route path="/law" element={<RedboxGlobalLaw />} />
          <Route path="/tax" element={<RedboxGlobalTax />} />
          <Route path="/government" element={<RedboxGovernment />} />
          <Route path="/nef" element={<RedboxNEF />} />
          <Route path="/advertising" element={<RedboxAdvertising />} />

          <Route path="/subscriptions/checkout" element={<Checkout />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/remote-login" element={<RemoteLogin />} />
         
         <Route path="/opinion/:slug" element={<OpinionDetail />} />

         <Route path="/live-tv" element={<LiveTv />} />
         <Route path="/youtube"element={<RedboxYoutube/>}/>
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookieSettings />} />
          <Route path="/help" element={<Help />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
         

       
        </Routes>
         
         </main>

        

        

        
          

         {/* ✅ Show Banner ONLY on Economics page */}
      {/* {location.pathname === "/economics" && <BottomBanner />} */}

        {/* Scroll to top / bottom — hidden on Sign In and Remote Login */}
        {!hideScrollButtons && <ScrollButtons />}

        {/* <BottomBanner /> */}
        
        <Footer />
      </div>
       );
}

  function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
